module.exports = require('./helpers/bundle-url').getBundleURL('9oV8V') + "logo-dark.eefe0b7f.svg";